module.exports = __webpack_public_path__ + "img/logo-training-black.19e0e8c9.png";